/**
 * Usability-Tests im UI (Header, Routen): nur bei explizitem Flag und nicht im Production-Build.
 * CRA ersetzt process.env.REACT_APP_* beim Build — Wert muss exakt der String "true" sein.
 */
export const isUsabilityTestsEnabled =
  process.env.REACT_APP_ENABLE_USABILITY_TESTS === 'true' &&
  process.env.NODE_ENV !== 'production';